export const getImprisonmentLength = (policeRecordScore: number): number => {
  return Math.max(30, -policeRecordScore);
};
